import { useSurveyStore } from "@store/survey";
import { Text, Flex, Box, ScrollArea } from "@radix-ui/themes";
import PropTypes from "prop-types";
import { sortLayersByOrder } from "@utils/helpers";

LegendLayer.propTypes = {
  name: PropTypes.string,
  layer: PropTypes.object,
  before_id: PropTypes.string,
};

function LegendLayer({ layer }) {
  const circleColor = layer.layer.paint["circle-color"];

  if (Array.isArray(circleColor) && circleColor[0] === "match") {
    const items = [];
    for (let i = 2; i < circleColor.length - 1; i += 2) {
      const proposalName = circleColor[i];
      const color = circleColor[i + 1];
      items.push({ proposalName, color });
    }

    return (
      <Box>
        <Text size="2" color="gray">
          {layer.name}
        </Text>
        {items.map((item, index) => (
          <Flex gap="2" direction="row" align="center" key={index}>
            <div
              style={{
                width: 8,
                height: 8,
                backgroundColor: item.color,
                border: "1px solid white",
                borderRadius: "50%",
                font: "unset",
              }}
            />
            <Text size="2">{item.proposalName}</Text>
          </Flex>
        ))}
      </Box>
    );
  }

  if (typeof circleColor === "string") {
    return (
      <Box>
        <Flex gap="2" direction="row" align="center" p="0">
          <div
            style={{
              width: 8,
              height: 8,
              backgroundColor: circleColor,
              border: "1px solid white",
              borderRadius: "50%",
              font: "unset",
            }}
          />
          <Text size="2">{layer.name}</Text>
        </Flex>
      </Box>
    );
  }

  if (layer.layer.type === "fill") {
    return (
      <Box>
        <Flex gap="2" direction="row" align="center" p="0">
          <div
            style={{
              width: 8,
              height: 8,
              backgroundColor: layer.layer.paint["fill-color"],
              opacity: layer.layer.paint["fill-opacity"],
              border: "1px solid white",
              borderRadius: "2px",
              font: "unset",
            }}
          />
          <Text size="2">{layer.name}</Text>
        </Flex>
      </Box>
    );
  }

  return null;
}

export default function Legend() {
  const { surveySectionLayers } = useSurveyStore((state) => ({
    surveySectionLayers: state.surveySectionLayers,
  }));

  if (!surveySectionLayers || surveySectionLayers.length === 0) return null;

  return (
    <ScrollArea
      scrollbars="vertical"
      size="1"
      style={{
        width: "100%",
        maxWidth: 230,
        maxHeight: 180,
        minHeight: "fit-content"
      }}
    >
      <Flex direction="column" className="radix-themes" p="2" gap="1">
        {sortLayersByOrder(surveySectionLayers).map((layer, idx) => (
          <Box key={idx}>
            <LegendLayer layer={layer} />
          </Box>
        ))}
      </Flex>
    </ScrollArea>
  );
}
